(function () {
    'use strict';

    run.superadmin.parts.toolEditor = function() {
        const iconPicker = new IconPicker(document.getElementById('icon'), {
            theme: 'bootstrap-5',
            iconSource: [
                {
                    key: 'brands',
                    prefix: '',
                    url: GlobalRoutes.appUrl+'/assets/fonts/extra-brands/list.json'
                },
                'FontAwesome Solid 5',
                'FontAwesome Brands 5',
            ],
            closeOnSelect: true,
        });
    };
})();